module.exports = __webpack_public_path__ + "static/img/main_bg_black_zh.6213c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/images/main_bg_black_zh.jpg
// module id = 6Q5f
// module chunks = 1